<template>
    <el-form-item label="包含工程内容">
        <el-table v-if="!readonly" ref="theTable" :data="tableRows" style="width: 100%" @selection-change="handleSelectionChange" >
            <el-table-column type="selection" width="55" v-if="!readonly"/>
            <el-table-column prop="prof" label="专业" width="180" >
                <template #default="scope">
                <span>{{scope.row.prof}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="rules" label="定额规则" >
                <template #default="scope">
                        <div v-show="isSelectedRow(scope)">
                            <el-radio-group 
                                v-model="scope.row.$$checkedRule" @change="emitValue()">
                                <el-radio v-for="(rule, idx) in scope.row.rules" :key="idx" :label="rule"></el-radio>
                            </el-radio-group>
                        </div>
                        <div >
                            {{scope.row.rule}}
                        </div>
                    </template>
            </el-table-column>
        </el-table>
        <el-table v-else :data="tableRows" style="width: 100%"  >
            <el-table-column prop="prof" label="专业" width="180" >
                <template #default="scope">
                    <el-icon ><circle-check-filled/></el-icon>
                    <span>{{scope.row.prof}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="rule" label="定额规则"  />
        </el-table>
    </el-form-item>

</template>
<script>
import _ from 'lodash'
import { defineComponent } from 'vue'
import fieldProps from './props';
import {setProperty,getProperty} from '@/utils/reflection'
import {PROJ,getContainsProfessions} from '@/utils/model'


export default defineComponent({
    
    computed:{
        containsProfessions(){

          const project = this.provideCurrentProject
            if(project){
                return getContainsProfessions(project.value)
            }  
            
        },
        schemaProfessions(){
             return this.rootSchema.properties[PROJ.INFO_CONTAINS_PROFESSION].items.enum
        },
        tableRows(){
            
            const data = []
            if(!this.readonly){
                
                if(this.schema){
                    const properties = this.schema.properties

                    this.schemaProfessions.forEach(prof => {
                        let rules = []
                        if(properties[prof] && properties[prof].enum){
                            rules = properties[prof].enum
                        }
                        const row = {prof, rules, $$checkedRule:''}
                        if(this.defaultVal){
                            const rule = this.defaultVal[prof]
                            if(rule){
                                row.$$checkedRule = rule
                            }
                        }
                            
                        data.push(row)
                    });   
                }
                          
            }else{

                if(this.containsProfessions && this.containsProfessions.length){
                    this.containsProfessions.forEach(prof => {
                     
                        let rule = ''
                        if(this.defaultVal && this.defaultVal[prof]){
                            rule = this.defaultVal[prof]
                        }
                        const row = {prof, rule}                            
                        data.push(row)
                    })
                }
            }

            return data            
        },
        readonly(){            
            if(this.genFormProvide){
                return this.genFormProvide.value.readonly
            }
        }
    },
    data(){
        return {
            defaultVal: getProperty(this.rootFormData, this.curNodePath),
            selection: [],
            initing: true
        }
    },
    
    inject:["provideCurrentProject",'genFormProvide'],
    methods:{
        handleSelectionChange(val){
            this.selection = val
            if(!this.initing){
                this.emitValue(val)
            }
        },
        emitValue(){
            if(this.readonly){
                return
            }
            const obj = {}
            this.selection.forEach(v => {
                obj[v.prof] = v.$$checkedRule||''
            });
            
            setProperty(this.rootFormData, this.curNodePath, obj);
            
            //同时更新包含工程内容
            setProperty(this.rootFormData, PROJ.INFO_CONTAINS_PROFESSION, Object.keys(obj));
        },
        isSelectedRow(scope){            
            if(scope.store){                
                return scope.store.isSelected(scope.row)
            }
            
        },
        init(){
            this.initing = true
            if (!this.readonly && this.defaultVal && this.tableRows && this.tableRows.length) {
                const defaultValKey = Object.keys(this.defaultVal)
                this.tableRows.forEach((row) => {
                    if(!_.isUndefined(this.defaultVal[row.prof])){
                        this.$refs.theTable.toggleRowSelection(row)
                    }            
                })
            } 
            this.initing = false
        }
    },
    
    props: {
        // 统一的 field props
        ...fieldProps
    },
    mounted(){
        this.init()
    }
})
</script>
